import type { AuthContextValue, LoginResult } from './domain';
import { createContext } from 'react';

// Initial value for the AuthContext, will be overridden by the provider
const create = () =>
	createContext<AuthContextValue>({
		login: async () => Promise.resolve({} as Promise<LoginResult>),
		logout: async () => Promise.resolve(),
		user: null,
		isUserLoading: false,
		isUserLoaded: false,
	});

export const AuthContext = create();
